// WhatsApp CTA utility for contextual prefilled messages
const WHATSAPP_NUMBER = '917625050588';

// Context-based messages
const WHATSAPP_MESSAGES = {
  // Homepage - general inquiry
  homepage: 'Hi ComplyKit, I need help understanding what compliance services I need.',
  
  // Business Setup category
  'business-setup': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  'proprietorship': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  'partnership': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  'llp': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  'private-limited': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  'opc': 'Hi ComplyKit, I want to start a business. Can you guide me on the best structure?',
  
  // GST category
  'gst': 'Hi ComplyKit, I need help with GST registration.',
  'gst-registration': 'Hi ComplyKit, I need help with GST registration.',
  'gst-return-filing': 'Hi ComplyKit, I need help with GST return filing.',
  'gst-lut': 'Hi ComplyKit, I need help with GST LUT filing.',
  'gst-cancellation': 'Hi ComplyKit, I need help with GST cancellation.',
  'gst-amendment': 'Hi ComplyKit, I need help with GST amendment.',
  
  // Trademark category
  'trademark': 'Hi ComplyKit, I want to register a trademark.',
  'trademark-registration': 'Hi ComplyKit, I want to register a trademark.',
  'trademark-objection': 'Hi ComplyKit, I need help with a trademark objection.',
  'trademark-opposition': 'Hi ComplyKit, I need help with trademark opposition.',
  'trademark-renewal': 'Hi ComplyKit, I need help with trademark renewal.',
  'trademark-assignment': 'Hi ComplyKit, I need help with trademark assignment.',
  
  // Licenses category
  'licenses': 'Hi ComplyKit, I need help with business licenses.',
  'fssai-registration': 'Hi ComplyKit, I need help with FSSAI registration.',
  'fssai-license': 'Hi ComplyKit, I need help with FSSAI license.',
  'import-export-code': 'Hi ComplyKit, I need help with Import Export Code (IEC).',
  'msme-registration': 'Hi ComplyKit, I need help with MSME/Udyam registration.',
  'shop-establishment': 'Hi ComplyKit, I need help with Shop & Establishment registration.',
  
  // MCA Compliance category
  'mca-compliance': 'Hi ComplyKit, I need help with MCA compliance.',
  'annual-filing': 'Hi ComplyKit, I need help with annual filing.',
  'director-change': 'Hi ComplyKit, I need help with director change.',
  'registered-office-change': 'Hi ComplyKit, I need help with registered office change.',
  
  // Tax & Payroll category
  'tax-payroll': 'Hi ComplyKit, I need help with tax and payroll compliance.',
  'income-tax-filing': 'Hi ComplyKit, I need help with income tax filing.',
  'tds-return': 'Hi ComplyKit, I need help with TDS return filing.',
  'pf-registration': 'Hi ComplyKit, I need help with PF registration.',
  'esi-registration': 'Hi ComplyKit, I need help with ESI registration.',
  
  // Fallback
  fallback: 'Hi ComplyKit, I need help with compliance services.'
};

/**
 * Get WhatsApp URL with contextual prefilled message
 * @param {string} context - The context key (service slug, category, or 'homepage')
 * @param {string} serviceName - Optional service name for dynamic messages
 * @returns {string} WhatsApp URL with prefilled message
 */
export const getWhatsAppUrl = (context = 'fallback', serviceName = null) => {
  let message;
  
  // If we have a specific service name, create a dynamic message
  if (serviceName && !WHATSAPP_MESSAGES[context]) {
    message = `Hi ComplyKit, I need help with ${serviceName}.`;
  } else {
    // Use predefined message or fallback
    message = WHATSAPP_MESSAGES[context] || WHATSAPP_MESSAGES.fallback;
  }
  
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

/**
 * Open WhatsApp with contextual message
 * @param {string} context - The context key
 * @param {string} serviceName - Optional service name
 */
export const openWhatsApp = (context = 'fallback', serviceName = null) => {
  const url = getWhatsAppUrl(context, serviceName);
  window.open(url, '_blank');
};

/**
 * Get context from service category slug
 * @param {string} categorySlug - The category slug
 * @returns {string} Context key for WhatsApp message
 */
export const getCategoryContext = (categorySlug) => {
  const categoryMap = {
    'business-setup': 'business-setup',
    'gst': 'gst',
    'trademark': 'trademark',
    'licenses': 'licenses',
    'mca-compliance': 'mca-compliance',
    'tax-payroll': 'tax-payroll'
  };
  return categoryMap[categorySlug] || 'fallback';
};

export default {
  getWhatsAppUrl,
  openWhatsApp,
  getCategoryContext,
  WHATSAPP_NUMBER
};
